// extracted by mini-css-extract-plugin
export default {"wrapper":"sCQp8I7tGNRRGQHnk_ZM"};